angular
    .module('dnecom.component.cart')
    .service('SignifyOnCartIconUtils', ["$http", "$q", "$cookies", "CartHash", function ($http, $q, $cookies, CartHash) {
        var self = this;

        self.getAvailableSignifyNotification = function() {
            var deferred = $q.defer();

            $http
                .get(Routing.generate('stores_fe_api_signify_get_available_by_type', {
                    type: 'on_cart_icon'
                }))
                .then(function(response) {
                    if (!response.data.success) {
                        deferred.resolve({success: false});
                    }

                    deferred.resolve(response.data);
                }, function() {
                    deferred.resolve({success: false});
                });

            return deferred.promise;
        };

        self.activateSignifyOnCartIcon = function(element, signifyNotification, storeView) {
            if (storeView == 'main') {
                self.onCartIconMain(element, signifyNotification, '#signify-on-cart-icon');
            } else if (storeView == 'main-mobile') {
                self.onCartIconMain(element, signifyNotification, '#signify-on-cart-icon-mobile');
            } else {
                self.onCartIconMobile(element, signifyNotification);
            }
        };
        self.deactivateSignifyOnCartIcon = function(element, signifyNotification, storeView) {
            if (storeView != 'main' && storeView != 'main-mobile') {
                $(element).parent().parent().unbind('click');
            }
        };

        self.onCartIconMain = function(element, signifyNotification, signifyElementId) {
            self.onCartIconCommon(signifyElementId, signifyNotification);

            $(element).parent().parent().on('mouseenter', function() {
                self.display(signifyElementId, signifyNotification);
            }).on('mouseleave', function () {
                $(signifyElementId).fadeOut(250);
            });
        };

        self.onCartIconMobile = function(element, signifyNotification) {
            var signifyElementId = '#signify-on-cart-icon';

            self.onCartIconCommon(signifyElementId, signifyNotification);

            $(element).parent().parent().bind('click', function(event) {
                event.preventDefault();

                if (!$(signifyElementId).is(':visible')) {
                    self.display(signifyElementId, signifyNotification);
                } else {
                    $(signifyElementId).fadeOut(250);
                }
            });
        };

        self.onCartIconCommon = function(signifyElementId, signifyNotification) {
            $(signifyElementId).html(signifyNotification.content);

            var cookieKey = 'signify_first_visit_displayed_' + signifyNotification.store;

            if (
                signifyNotification.fields.hasOwnProperty('autoSignify')
                && signifyNotification.fields.hasOwnProperty('autoSignifyDelay')
                && signifyNotification.fields.autoSignify
                && signifyNotification.fields.autoSignifyDelay
                && _.isUndefined($cookies.getObject(cookieKey))
            ) {
                setTimeout(function() {
                    self.display(signifyElementId, signifyNotification);
                }, signifyNotification.fields.autoSignifyDelay * 1000);

                $cookies.putObject(cookieKey, 1);
            }
        };

        self.display = function(signifyElementId, signifyNotification) {
            $(signifyElementId).fadeIn(250);
            $http
                .get(Routing.generate('stores_fe_api_signify_increment_display_count', {
                    hash: signifyNotification.hash
                }));
        };

        return self;
    }]);